import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TrendingUp } from "lucide-react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { format } from "date-fns";

export default function RevenueChart({ billing, isLoading }) {
  if (isLoading) {
    // Return a skeleton loader
    return (
      <Card className="bg-white/60 backdrop-blur-sm border-slate-200/60 shadow-xl">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-slate-900">
            <TrendingUp className="w-5 h-5 text-green-600" />
            Monthly Revenue
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-80 animate-pulse bg-slate-200/50 rounded-lg"></div>
        </CardContent>
      </Card>
    );
  }

  // Process billing data to get monthly totals
  const monthlyRevenue = billing.reduce((acc, bill) => {
    const billDate = new Date(bill.billing_date);
    if (isNaN(billDate.getTime())) return acc; // Skip invalid dates
    const month = format(billDate, "MMM yyyy");
    acc[month] = (acc[month] || 0) + (bill.total_amount || 0);
    return acc;
  }, {});

  const chartData = Object.keys(monthlyRevenue)
    .map((month) => ({
      name: month.split(" ")[0], // 'Jan', 'Feb', etc.
      revenue: monthlyRevenue[month],
    }))
    .slice(-6); // Show last 6 months

  return (
    <Card className="bg-white/60 backdrop-blur-sm border-slate-200/60 shadow-xl">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-slate-900">
          <TrendingUp className="w-5 h-5 text-green-600" />
          Monthly Revenue
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="name" stroke="#64748b" fontSize={12} />
              <YAxis
                stroke="#64748b"
                fontSize={12}
                tickFormatter={(value) => `$${(value / 1000).toFixed(0)}k`}
              />
              <Tooltip
                cursor={{ fill: "rgba(240, 249, 255, 0.5)" }}
                formatter={(value) => [`$${value.toLocaleString()}`, "Revenue"]}
                contentStyle={{
                  backgroundColor: "rgba(255, 255, 255, 0.95)",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                }}
              />
              <Bar dataKey="revenue" fill="#22c55e" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
